import { Box, Icon, Typography } from "@mui/material";
import { useState, useEffect, CSSProperties } from "react";
import { PRIMARY_COLOR, SECONDARY_COLOR, SUCCESS_COLOR, DANGER_COLOR, INFO_COLOR, WARNING_COLOR } from "../../_const/color.const";


export const useButtonStyles = (
    width: string,

    style?: 'slanted' | 'default' | 'pullPlanningModule' | 'pullPlanningModuleMiniY'
) => ({
    mainContainer: {
    },
    compact: {
        paddingLeft: "0px",
        paddingRight: "0px"
    },
    button: {
        borderRadius: "4px",
        color: "white",
        textTransform: "uppercase",
        width: `${width}`,
        marginLeft: style == 'slanted' ? "-2px !important" : "0px !important",
        marginBottom: style == 'slanted' ? "-10px !important" : "0px !important",
        marginTop: style == 'slanted' ? "-6px" : "0px",
        minHeight: style === "pullPlanningModuleMiniY" ? "50%" : style === "pullPlanningModule" ? "30px" : style == 'slanted' ? "35px" : "38px",
        float: style === "pullPlanningModuleMiniY" ? "left" : "none",
        maxHeight: "75px",
        padding: style === "pullPlanningModule" || style === "pullPlanningModuleMiniY" ? "0px" : "auto",
        paddingLeft: '10px',
        "&:hover": {
            color: "white",
            boxShadow: "none",
            cursor: "pointer"
        },
        "&:disabled": {
            backgroundColor: "silver !important",
            color: "black !important",
            cursor: "auto !important"
        },
    },
    cellButton: {
        marginTop: "0px",
        height: "100%"
    },

    primaryButton: {
        backgroundColor: PRIMARY_COLOR[0],
        "&:hover,&:focus": {
            backgroundColor: SUCCESS_COLOR[0]
        }
    },

    disabledButton: {
        backgroundColor: "silver",
        cursor: "auto !important",
        border: "none !important",
        "&:hover,&:focus": {
            backgroundColor: SUCCESS_COLOR[0]
        }
    },

    secondaryButton: {
        backgroundColor: SECONDARY_COLOR,
        "&:hover,&:focus": {
            backgroundColor: SECONDARY_COLOR
        }
    },

    activeButton: {
    },

    successsButton: {
        backgroundColor: SUCCESS_COLOR[0],
        "&:hover,&:focus": {
            backgroundColor: SUCCESS_COLOR[1]
        }
    },

    dangerButton: {
        backgroundColor: DANGER_COLOR[0],
        "&:hover,&:focus": {
            backgroundColor: DANGER_COLOR[1]
        }
    },

    infoButton: {
        backgroundColor: INFO_COLOR[0],
        "&:hover,&:focus": {
            backgroundColor: INFO_COLOR[1]
        }
    },

    warningButton: {
        backgroundColor: WARNING_COLOR[0],
        "&:hover,&:focus": {
            backgroundColor: WARNING_COLOR[1]
        }
    },

    defaultButton: {
        backgroundColor: '#e0e0e0',
        color: "black",
        "&:hover,&:focus": {
            color: "black",
            backgroundColor: '#d5d5d5'
        }
    },



    /*slanted*/
    // buttonDefault: {
    //     color: "white",
    //     backgroundColor: "teal",
    //     textAlign: "center",
    //     textTransform: "uppercase",
    //     padding: "5px 10px",
    //     margin: "10px",
    //     display: "inline-block",
    // },

    buttonSlanted: {
        "-ms-transform": "skewX(-45deg)",
        "-webkit-transform": "skewX(-45deg)",
        transform: "skewX(-45deg)"
    },

    buttonSlantedContent: {
        "-ms-transform": "skewX(45deg)",
        "-webkit-transform": "skewX(45deg)",
        "transform": "skewX(45deg)",
        "display": "inline-block",
        "& *": {
            "-ms-transform": "skewX(45deg)",
            "-webkit-transform": "skewX(45deg)",
            "transform": "skewX(45deg)",
        },
        "& span": {
            "-ms-transform": "skewX(0deg)",
            "-webkit-transform": "skewX(0deg)",
            "transform": "skewX(0deg)",
        },
    },

    buttonFixedwidth: {
        width: "100px"
    },

});

export const PrimaryButton = (params: {
    children?: React.ReactNode,
    styles?: CSSProperties | undefined,
    variant: 'primary' | 'secondary' | 'active' | 'success' | 'danger' | 'info' | 'warning' | 'save' | 'remove' | 'default'
    type?: 'button' | 'submit',
    style?: 'slanted' | 'default' | 'pullPlanningModule' | 'pullPlanningModuleMiniY',
    compact?: boolean,
    cellButton?: boolean,
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
    disabled?: boolean,
    isSaving?: boolean,
    isLoading?: boolean,
    width?: string,
    title?: string,
    icon?: string,
    fullHeight?: boolean
}) => {

    const buttonClasses = useButtonStyles(params.width || "100%", params.style || "default");

    let buttonClass: any = {};

    switch (!params.disabled ? params.variant : "disabled") {
        case ("disabled"):
            buttonClass = buttonClasses.disabledButton; break;
        case ("default"):
            buttonClass = buttonClasses.defaultButton; break;
        case ("primary"):
        case ("save"):
            buttonClass = buttonClasses.primaryButton; break;
        case ("secondary"): buttonClass = buttonClasses.secondaryButton; break;
        case ("active"): buttonClass = buttonClasses.activeButton; break;
        case ("success"): buttonClass = buttonClasses.successsButton; break;
        case ("danger"):
        case ("remove"):
            buttonClass = buttonClasses.dangerButton; break;
        case ("info"): buttonClass = buttonClasses.infoButton; break;
        case ("warning"): buttonClass = buttonClasses.warningButton; break;
    }

    const _icon = params.icon ? <Icon>{params.icon}</Icon> : params.variant === 'save' ? <Icon>check</Icon> : params.variant === 'remove' ? <Icon>clear</Icon> : <></>;

    return (
        <button
            type={params.type || 'button'}
            style={{ ...buttonClasses.button, ...buttonClass, ...(params.compact ? buttonClasses.compact : {}), ...(params.cellButton ? buttonClasses.cellButton : ""), ...params.styles, ...(params.fullHeight ? { height: "100%" } : "") }}
            disabled={params.disabled === true || params.isLoading === true || params.isSaving === true}
            className={params.disabled ? ` ` : `btn`}
            onClick={params.onClick}
            title={params.title} >

            <span className={` ${params.style === 'slanted' ? "buttonSlantedContent" : ""}`}>
                {(params.isSaving !== true && params.isLoading !== true) &&
                    <Box display="flex" justifyContent="center" alignItems="center" gap={1}>

                        {params.children && <Typography letterSpacing={1}>{params.children}</Typography>}

                        {_icon}

                    </Box>
                }

                {(params.isSaving === true) &&
                    <>Saving<LoadingDots /></>
                }

                {(params.isLoading === true) &&
                    <>Loading<LoadingDots /></>
                }
            </span>
        </button >
    );
}

const LoadingDots = () => {
    const [loadingStatus, setLoadingStatus] = useState("..");

    useEffect(() => {
        const intervalId = setInterval(() => {
            setLoadingStatus(ls => ls.length >= 5 ? ".." : ls + ".");
        }, 400);

        return () => clearInterval(intervalId);
    }, []);

    return <>{`${loadingStatus}`}</>;
};